import { render, staticRenderFns } from "./InvitationList.vue?vue&type=template&id=543280fd&"
import script from "./InvitationList.vue?vue&type=script&lang=js&"
export * from "./InvitationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543280fd')) {
      api.createRecord('543280fd', component.options)
    } else {
      api.reload('543280fd', component.options)
    }
    module.hot.accept("./InvitationList.vue?vue&type=template&id=543280fd&", function () {
      api.rerender('543280fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/onboarding/components/InvitationList.vue"
export default component.exports